import { Localisation } from '@1x2network/legacy_localisation'

/**
 *  Handle loading and applying translations
 *  @author Jordan Harrison - <jordan.harrison@1x2network.com>
 *  @version 1.0.0
 */

/** list of game translations to apply */
export const gameTranslations = {
    'splash_text-0':
        'The Collector Symbol in the Hold & Win collects the values of all Hold & Win Symbols on the board!',
    'splash_text-1': 'Land 5+ special bonus symbols including a collector to trigger the Hold & Win bonus!',
    'splash_text-2': 'Activate the ante bet to double the chance of hitting the Hold & Win bonus',
    'paytable_symbol-09-collector':
        'Special Collector Symbol - Collects all variants of Cash Symbols, with cash values and jackpot values on them',
    'paytable_symbol-10-cash':
        'Special Bonus Symbol - Displays a cash value that can be collected by the Collector symbol',
    'paytable_symbol-11-mini': 'Special Mini Hold & Win Prize Symbol.',
    'paytable_symbol-12-minor': 'Special Minor Hold & Win Prize Symbol.',
    'paytable_symbol-13-major': 'Special Major Hold & Win Prize Symbol.',
    'paytable_symbol-14-mega': 'Special Mega Hold & Win Prize Symbol.',
    'antebet_title-100': 'Bet +50%',
    'antebet_description-100': 'Double chance of Hold & Win Bonus',
    'transition_text-1': 'Collectors stick and collect Cash Symbols every spin!',
}

/** type utility for keys of the localisation */
export type GameTranslationKeys = keyof typeof gameTranslations

/** singleton for the game localisation */
export const GAME_LOCALISATION = new Localisation({
    translations: gameTranslations,
})
